export const EMPLOYEES_SEND_NOTIFICATION_CLEAR = 'EMPLOYEES_SEND_NOTIFICATION_CLEAR';

export const GET_USERS_ACTION_REQUEST = 'GET_USERS_ACTION_REQUEST';
export const GET_USERS_ACTION_SUCCESS = 'GET_USERS_ACTION_SUCCESS';
export const GET_USERS_ACTION_FAILURE = 'GET_USERS_ACTION_FAILURE';
export const GET_USERS_ACTION = 'GET_USERS_ACTION';

export const ADD_ROLE_ACTION_REQUEST = 'ADD_ROLE_ACTION_REQUEST';
export const ADD_ROLE_ACTION_SUCCESS = 'ADD_ROLE_ACTION_SUCCESS';
export const ADD_ROLE_ACTION_FAILURE = 'ADD_ROLE_ACTION_FAILURE';
export const ADD_ROLE_ACTION = 'ADD_ROLE_ACTION';

export const DELETE_ROLE_ACTION_REQUEST = 'DELETE_ROLE_ACTION_REQUEST';
export const DELETE_ROLE_ACTION_SUCCESS = 'DELETE_ROLE_ACTION_SUCCESS';
export const DELETE_ROLE_ACTION_FAILURE = 'DELETE_ROLE_ACTION_FAILURE';
export const DELETE_ROLE_ACTION = 'DELETE_ROLE_ACTION';

export const BREAKPOINT_MD = 750;
